<div class="modal-header card-header">
    <span class="text-blue text-125">Control de personal de campo</span>
    <button type="button" class="btn btn-danger btn-sm ml-auto" (click)="activeModal.close()" title="Cerrar">
        <i class="fa fa-times"></i>
    </button>
</div>

<div class="modal-body">
    <p class="text-muted text-90 mb-3">
        Los horarios, la tolerancia y los días de cada turno se configuran en <b>Turnos</b> y se asignan a cada asesor.
        Acá van las demás reglas del control.
    </p>

    <div *ngIf="cargando" class="text-center py-3"><i class="fa fa-spinner fa-spin"></i></div>

    <form *ngIf="!cargando" (ngSubmit)="guardar()">
        <div class="form-group row">
            <label class="col-sm-6 col-form-label" for="minimo_lugares">Mínimo de lugares por turno</label>
            <div class="col-sm-3">
                <input id="minimo_lugares" class="form-control" type="number" min="0" name="minimo_lugares_turno"
                    [(ngModel)]="configuracion.minimo_lugares_turno">
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-6 col-form-label" for="minutos_traslado">Traslado máximo entre lugares (min)</label>
            <div class="col-sm-3">
                <input id="minutos_traslado" class="form-control" type="number" min="0" name="minutos_traslado"
                    [(ngModel)]="configuracion.minutos_traslado">
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-6 col-form-label" for="distancia_maxima">Distancia GPS permitida al colegio (m)</label>
            <div class="col-sm-3">
                <input id="distancia_maxima" class="form-control" type="number" min="0" name="distancia_maxima"
                    [(ngModel)]="configuracion.distancia_maxima">
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-6 col-form-label" for="fecha_inicio_campania">Inicio de campaña</label>
            <div class="col-sm-3">
                <input id="fecha_inicio_campania" class="form-control" type="date" name="fecha_inicio_campania"
                    [(ngModel)]="configuracion.fecha_inicio_campania">
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-6 col-form-label" for="foto_obligatoria">Foto obligatoria al marcar "Llegué"</label>
            <div class="col-sm-3 pt-2">
                <input id="foto_obligatoria" type="checkbox" name="foto_obligatoria" [(ngModel)]="configuracion.foto_obligatoria">
            </div>
        </div>
        <button type="submit" class="btn btn-primary" [disabled]="guardando">
            <i class="fa fa-save"></i> Guardar
        </button>
    </form>

    <hr>

    <h6 class="text-blue">Feriados</h6>
    <p class="text-muted text-90">
        Días sin trabajo para todos los asesores: tienen 0 horas esperadas. Para un solo asesor, usá "Ajustar día" en el reporte.
    </p>
    <div class="d-flex align-items-center flex-wrap mb-2 feriado-nuevo">
        <input type="date" class="form-control form-control-sm" name="feriado_fecha" [(ngModel)]="nuevoFeriado.fecha" aria-label="Fecha del feriado">
        <input type="text" class="form-control form-control-sm" name="feriado_nombre" [(ngModel)]="nuevoFeriado.nombre"
            placeholder="Nombre (ej. Todos Santos)" maxlength="150" aria-label="Nombre del feriado">
        <button type="button" class="btn btn-sm btn-primary" (click)="agregarFeriado()">
            <i class="fa fa-plus"></i> Agregar
        </button>
    </div>
    <div *ngIf="!feriados.length" class="text-muted">No hay feriados cargados.</div>
    <table *ngIf="feriados.length" class="table table-sm table-bordered">
        <tbody>
            <tr *ngFor="let f of feriados">
                <td class="text-nowrap">{{ fechaFeriado(f.fecha) }}</td>
                <td>{{ f.nombre }}</td>
                <td class="text-right">
                    <button type="button" class="btn btn-sm btn-outline-danger" (click)="eliminarFeriado(f)" title="Eliminar feriado">
                        <i class="fa fa-trash"></i>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>

    <hr>

    <h6 class="text-blue">Ubicaciones de colegios por aprobar</h6>
    <p class="text-muted text-90">
        Las marcó un asesor desde la app con "Guardar ubicación de este colegio". Al aprobarla pasa a ser la ubicación
        oficial del cliente, con la que se mide la distancia de cada llegada.
    </p>
    <div *ngIf="!propuestas.length" class="text-muted">No hay ubicaciones pendientes.</div>
    <table *ngIf="propuestas.length" class="table table-sm table-bordered">
        <thead>
            <tr>
                <th>Cliente</th>
                <th>Propuesta</th>
                <th>Diferencia con la actual</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let p of propuestas">
                <td>
                    {{ p.razon_social }}
                    <small class="d-block text-muted">{{ p.direccion }}</small>
                </td>
                <td>
                    <a href="javascript:void(0)" (click)="verEnMapa(p.latitud_propuesta, p.longitud_propuesta)">Ver en mapa</a>
                    <small class="d-block text-muted">
                        {{ p.usuario_propuesta }} · {{ p.fecha_ubicacion_propuesta | date: 'dd/MM/yyyy HH:mm' }}
                    </small>
                </td>
                <td>
                    <span *ngIf="p.distancia_actual !== null">{{ p.distancia_actual }} m</span>
                    <span *ngIf="p.distancia_actual === null" class="text-muted">Sin ubicación actual</span>
                </td>
                <td class="text-nowrap">
                    <button type="button" class="btn btn-sm btn-success" (click)="resolver(p, true)">Aprobar</button>
                    <button type="button" class="btn btn-sm btn-outline-danger ml-1" (click)="resolver(p, false)">Descartar</button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
